import React, {useEffect, useRef, useState} from 'react';
import {Link, useHistory, useLocation, withRouter} from "react-router-dom";
import Button from 'react-bootstrap/Button';
import {downloadAPI, getAPI} from "../APIUtil";
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import AppNav from "./AppNav";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {sortCaret} from "../MdDataTable";
import {
  addField, checkKey, dateformatDatePicker, dateformatDB, dateformatJPNMMDD,
  dateformatYYYY_MM_DD,
  finishLoadingBtn, focusById,
  formatNumber,
  isLatestVersion,
  jumpToTopByDevice, nvl, onFocusText, onKeyDownNext, onKeyDownShortCut,
  parseDate, toSingleByteNumberOnly,
} from "../CMUtil";
import {Card, Col, Container, Form, InputGroup, Row} from "react-bootstrap";
import {
  faCalendar,
  faFileDownload,
} from "@fortawesome/free-solid-svg-icons";
import DatePicker, {registerLocale} from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import ja from "date-fns/locale/ja";
import MdDataTable from "../MdDataTable";

registerLocale('ja', ja)

export const ExpList = () => {

  const history = useHistory();
  const {search} = useLocation();
  const iniSearch = useRef(true);

  const [prvURL, setPrvURL] = useState("");

  const [loading, setLoading] = useState(true);
  const [locPage, setLocPage] = useState(null);
  const [locSizePerPage, setLocSizePerPage] = useState(100);
  const [locTotalSize, setLocTotalSize] = useState(null);
  const [locSortField, setLocSortField] = useState(null);
  const [locSortOrder, setLocSortOrder] = useState(null);

  const [payDateFrom, setPayDateFrom] = useState("");
  const [payDateTo, setPayDateTo] = useState("");
  const [payGrpNum, setPayGrpNum] = useState("");
  const [keyword, setKeyword] = useState("");
  const [listData, setListData] = useState([]);

  const [selectedId, setSelectedId] = useState(null);

  // 項目定義
  const columns = [
    {
      dataField: 'exp_id',
      text: '詳細',
      classes: 'tbl-col link text-center',
      sort: true,
      headerStyle: {width: '80px', textAlign: "center"},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        <div><a onClick={() => onClickLinkToDetail(row.exp_id, row.item_cd)}>詳細</a></div>
      )
    },
    {
      dataField: 'exp_date',
      text: '処理日',
      classes: 'tbl-col text-center',
      sort: true,
      headerStyle: {width: '100px', textAlign: "center"},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        <span>{cell ? dateformatJPNMMDD(parseDate(cell)) : ''}</span>
      )
    },
    {
      dataField: 'pay_date',
      text: '支払日',
      classes: 'tbl-col text-center',
      sort: true,
      headerStyle: {width: '100px', textAlign: "center"},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        <span>{cell ? dateformatJPNMMDD(parseDate(cell)) : ''}</span>
      )
    },
    {
      dataField: 'pay_grp_num',
      text: 'ｸﾞﾙｰﾌﾟ',
      classes: 'tbl-col text-center',
      sort: true,
      headerStyle: {width: '70px', textAlign: "center"},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        <span>{cell ? row.pay_grp_num : ''}</span>
      )
    },
    {
      dataField: 'author_cd',
      text: '支払先',
      classes: 'tbl-col',
      sort: true,
      // headerStyle: {width: '230px'},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        <span className="d-inline-block" tabIndex="0" data-toggle="tooltip" title={nvl(cell) + " " + nvl(row.penname_nm)}>
          {nvl(cell) + " " + nvl(row.penname_nm)}
        </span>
      )
    },
    {
      dataField: 'status',
      text: 'ステータス',
      classes: 'tbl-col text-center col-tag-status',
      sort: true,
      headerStyle: {width: '120px', textAlign: "center"},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        <div className={!cell ? 'd-inline-block' :
          cell === '新規' ? 'd-inline-block tag-status status-00' :
            cell === '支払前' ? 'd-inline-block tag-status status-01' :
              cell === '副社長承認中' ? 'd-inline-block tag-status status-10' :
                cell === '社長承認中' ? 'd-inline-block tag-status status-20' :
                  cell === '処理中' ? 'd-inline-block tag-status status-30' :
                    cell === '支払済' ? 'd-inline-block tag-status status-90' :
                      'd-inline-block'
        } tabIndex="0">
          {cell ? cell : ''}
        </div>
      )
    },
    {
      dataField: 'total_amount',
      text: '合計金額',
      classes: 'tbl-col text-right',
      headerStyle: {width: '100px', textAlign: "right"},
      formatter: (cell, row) => (
        <span>{formatNumber(cell)}</span>
      )
    },
    {
      dataField: 'withholding_tax_amount',
      text: '源泉金額',
      classes: 'tbl-col text-right',
      headerStyle: {width: '100px', textAlign: "right"},
      formatter: (cell, row) => (
        <span>{formatNumber(cell)}</span>
      )
    },
    {
      dataField: 'pay_amount',
      text: '支払金額',
      classes: 'tbl-col text-right',
      headerStyle: {width: '100px', textAlign: "right"},
      formatter: (cell, row) => (
        <span>{formatNumber(cell)}</span>
      )
    },
  ];

  // HOOK ////////////////////////////////////////////////////////////////////////////////////
  // 初期化
  useEffect(() => {

    // URLパラメータ
    const query = new URLSearchParams(search);
    const pPayDateTo = query.get("pay_date_to");
    const pPayDateFrom = query.get("pay_date_from");
    const pPayGrpNum = query.get("pay_grp_num");
    setPrvURL(query.get("prv_url"));
    // 検索履歴
    let exp_search_condition = localStorage.getItem("exp_search_condition");
    if (pPayDateFrom && pPayDateTo && pPayGrpNum) {
      // URLパラメータから検索
      pPayDateFrom ? setPayDateFromSearch(pPayDateFrom) : null;
      pPayDateTo ? setPayDateToSearch(pPayDateTo) : null;
      pPayGrpNum ? setPayGrpNumSearch(pPayGrpNum) : null;

    }else if(exp_search_condition) {
      let s = JSON.parse(exp_search_condition);
      s.pay_date_from ? setPayDateFromSearch(s.pay_date_from) : null;
      s.pay_date_to ? setPayDateToSearch(s.pay_date_to) : null;
      s.pay_grp_num ? setPayGrpNumSearch(s.pay_grp_num) : null;
      s.keyword ? setKeywordSearch(s.keyword) : null;
      s.page ? setLocPage(s.page) : setLocPage(1);
      s.size_per_page ? setLocSizePerPage(s.size_per_page) : null;
      s.sort_field ? setLocSortField(s.sort_field) : null;
      s.sort_order ? setLocSortOrder(s.sort_order) : null;
      s.prv_url ? setPrvURL(s.prv_url) : null;
    } else {
      setLocSortField("exp_id");
      setLocSortOrder("desc");
      setLocPage(1);
    }

    const init = async () => {
      await isLatestVersion(false);
      jumpToTopByDevice(history);
    }

    init();
  }, []);

  // 検索
  useEffect(() => {
      if (iniSearch.current) {
        iniSearch.current = false;
        return;
      }
      const update = async () => {
        await executeSearch(false);
      }
      update();
    },
    [
      locSizePerPage,
      locSortField,
      locSortOrder,
      locPage
    ]
  );

  // ロジック /////////////////////////////////////////////////////////////////////////////////
  // 検索
  const executeSearch = async (isCtlEnter = false) => {

    let condition = {};

    let sortField = locSortField;
    let sortOrder = locSortOrder;

    addField(condition, "page", locPage);
    addField(condition, "size_per_page", locSizePerPage);
    addField(condition, "sort_field", sortField);
    addField(condition, "sort_order", sortOrder);
    addField(condition, "pay_date_from", payDateFrom);
    addField(condition, "pay_date_to", payDateTo);
    addField(condition, "pay_grp_num", payGrpNum);
    addField(condition, "keyword", keyword);
    addField(condition, "prv_url", prvURL);

    localStorage.setItem("exp_search_condition", JSON.stringify(condition)); // 検索条件保持
    const res = await getAPI("tr_exp_search_view", condition);
    setListData(res);
    if (isCtlEnter && res.results.length > 0) {
      setSelectedId(res.results[0].row_id);
    }
  }

  // 一覧イベント /////////////////////////////////////////////////////////////////////////////

  const onTableChange = (type, {page, sizePerPage, filters, sortField, sortOrder, cellEdit}) => {
    if ("pagination" === type) {
      setLocPage(page);
    }
    if ("sort" === type) {
      setLocSortField(sortField);
      setLocSortOrder(sortOrder);
    }
  }

  const onClickLinkToDetail = (exp_id, item_cd) => {
    if (exp_id) {
      history.push("/exp_dtl/" + exp_id + "/");
    } else {
      history.push("/exp_dtl/?item_cd=" + item_cd);
    }
  }

  const onClickDownload = async () => {

    let condition = {};
    let sortField = locSortField;
    let sortOrder = locSortOrder;

    addField(condition, "page", locPage);
    addField(condition, "size_per_page", 99999);
    addField(condition, "sort_field", sortField);
    addField(condition, "sort_order", sortOrder);
    addField(condition, "pay_date", dateformatDB(payDate));
    addField(condition, "pay_grp_num", payGrpNum);
    addField(condition, "keyword", keyword);

    await downloadAPI("download/exp_list", condition);
    finishLoadingBtn("btn-download");
  }

  const onClickClear = (e) => {
    setPayDateFromSearch("");
    setPayDateToSearch("");
    setPayGrpNumSearch("");
    setKeywordSearch("");
    setLocSortField("exp_id");
    localStorage.removeItem("exp_search_condition");
  }

  const setPayDateFromSearch = (value) => {
    if (value > new Date(2999, 12, 31)) {
      //不正日付対応
      return;
    }
    setLocPage(1);
    setPayDateFrom(value);
  }

  const setPayDateToSearch = (value) => {
    if (value > new Date(2999, 12, 31)) {
      //不正日付対応
      return;
    }
    setLocPage(1);
    setPayDateTo(value);
  }

  const setPayGrpNumSearch = (value) => {
    console.log(value);
    setLocPage(1);
    setPayGrpNum(value);
  }

  const setKeywordSearch = (value) => {
    setLocPage(1);
    setKeyword(value);
  }

  // ショートカットキー /////////////////////////////////////////////////////////////////////////////////
  // Ctl＋Shift + Enter
  const onKeyDownCtlShiftEnter = async (e) => {
    onClickClear();
    await onKeyDownEsc();
  }

  // Ctl＋Enter
  const onKeyDownCtlEnter = async (e) => {
    let count = await executeSearch(true);
    if (count === 0) {
      await focusById("schedulePayMonth");
      return;
    }
    await focusById("data-table");
  }

  // Escape
  const onKeyDownEsc = async (e) => {
    if(e.target.id === "payDateFrom" && prvURL) {
      history.push(prvURL);
    }
    setSelectedId("");
    await focusById("payDateFrom");
  }

  // Space
  const onKeyDownSpace = async (e) => {
    //無効化
  }

  // Enter
  const onKeyDownEnter = async (e) => {
    if (e && e.target && (e.target.tagName === "INPUT")) {
      await onKeyDownNext(e);
    }
  }

  // ショートカットキー:一覧用 /////////////////////////////////////////////////////////////////////////////////
  // Ctl＋Enter
  const onKeyDownCtlEnterDataList = async (e) => {
    onClickLinkToDetail(e.selected[0]);
  }

  // Escape
  const onKeyDownEscDataList = async (e) => {
    await onKeyDownEsc(e);
  }

  const onKeyDownSpaceDataList = async (e) => {
    onClickLinkToDetail(e.selected[0]);
  }

  // カレンダー用 /////////////////////////////////////////////////////////////////////////////

  const [openCalPayDateFrom, setOpenCalPayDateFrom] = useState(false);
  const handleChangeCalPayDateFrom = async (dateObj) => {
    setPayDateFrom(dateformatYYYY_MM_DD(dateObj))
    setOpenCalPayDateFrom(false);
    await focusById("payDateFrom");
  };

  const [openCalPayDateTo, setOpenCalPayDateTo] = useState(false);
  const handleChangeCalPayDateTo = async (dateObj) => {
    setPayDateTo(dateformatYYYY_MM_DD(dateObj))
    setOpenCalPayDateTo(false);
    await focusById("payDateTo");
  };

  return (
    <>
      <AppNav/>
      <div
        onKeyDown={(e) => onKeyDownShortCut(e, () => onKeyDownCtlShiftEnter(e), () => onKeyDownCtlEnter(e), () => onKeyDownEsc(e), () => onKeyDownSpace(e), () => onKeyDownEnter(e))}
      >

        <Row className="h1">
          <Col sm={11}>
            <h1>
              経費一覧
            </h1>
          </Col>
          <Col sm={1}>
            {prvURL &&
              <Button id="btnBack" as={Link} to={prvURL} variant="quaternary" className="mr-4">
                戻る
              </Button>
            }
          </Col>
        </Row>
        <Card className="exp-list-card-search card-search">
          <Container className="container-main-search">
            <Form.Group as={Row}>
              <Form.Label column sm="1">支払日</Form.Label>
              <Col sm="5" className="input-group">
                <div className="input-group" style={{width: "163px"}}>
                  <Form.Control
                    id="payDateFrom"
                    type="text"
                    className="text-center"
                    inputMode="numeric"
                    tabIndex={11}
                    value={payDateFrom}
                    onKeyPress={e => checkKey(e, /^[\d-]+$/)}
                    onChange={e => setPayDateFrom(e.target.value)}
                    onFocus={e => onFocusText(e)}
                    onBlur={e => setPayDateFrom(dateformatYYYY_MM_DD(dateformatDatePicker(e.target.value)))}
                    autoFocus={true}
                  />
                  <button
                    type="button"
                    onClick={e => setOpenCalPayDateFrom(true)}
                    style={{
                      position: "absolute",
                      top: "0.4rem",
                      right: "0.2rem",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      zIndex: 5
                    }}>
                    <FontAwesomeIcon icon={faCalendar}/>
                  </button>
                </div>
                <DatePicker
                  wrapperClassName="display-none-date-wrapper"
                  selected={dateformatDatePicker(toSingleByteNumberOnly(payDateFrom))}
                  onChange={handleChangeCalPayDateFrom}
                  open={openCalPayDateFrom}
                  onClickOutside={e => setOpenCalPayDateFrom(false)}
                  customInput={<div style={{display: "none"}}/>}
                  dateFormat="yyyy-MM-dd"
                  popperPlacement="bottom-start"
                  disabledKeyboardNavigation
                  locale="ja"
                />
                <InputGroup.Text style={{border: "0px", backgroundColor: "#ffffff"}}>～</InputGroup.Text>
                <div className="input-group" style={{width: "163px"}}>
                  <Form.Control
                    id="payDateTo"
                    type="text"
                    className="text-center"
                    inputMode="numeric"
                    tabIndex={12}
                    value={payDateTo}
                    onKeyPress={e => checkKey(e, /^[\d-]+$/)}
                    onChange={e => setPayDateTo(e.target.value)}
                    onFocus={e => onFocusText(e)}
                    onBlur={e => setPayDateTo(dateformatYYYY_MM_DD(dateformatDatePicker(e.target.value)))}
                  />
                  <button
                    type="button"
                    onClick={e => setOpenCalPayDateTo(true)}
                    style={{
                      position: "absolute",
                      top: "0.4rem",
                      right: "0.2rem",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      zIndex: 5
                    }}>
                    <FontAwesomeIcon icon={faCalendar}/>
                  </button>
                </div>
                <DatePicker
                  selected={dateformatDatePicker(toSingleByteNumberOnly(payDateTo))}
                  onChange={handleChangeCalPayDateTo}
                  open={openCalPayDateTo}
                  onClickOutside={e => setOpenCalPayDateTo(false)}
                  customInput={<div style={{display: "none"}}/>}
                  dateFormat="yyyy-MM-dd"
                  popperPlacement="bottom-start"
                  disabledKeyboardNavigation
                  locale="ja"
                />
              </Col>
              <Form.Label column sm="1">Gno</Form.Label>
              <Col sm="1" className="input-group">
                <Form.Control
                  type="text"
                  tabIndex={14}
                  value={payGrpNum}
                  onChange={e => setPayGrpNumSearch(e.target.value)}
                  onFocus={e => onFocusText(e)}/>
              </Col>
              <Form.Label column sm="1">検索</Form.Label>
              <Col sm="3" className="input-group">
                <Form.Control
                  id="keyword"
                  type="text"
                  tabIndex={16}
                  value={keyword}
                  onChange={e => setKeywordSearch(e.target.value)}
                  onFocus={e => onFocusText(e)}/>
              </Col>
            </Form.Group>
            <Form.Group as={Row} style={{marginTop:"1rem"}}>
              <Col></Col>
              <Col sm="11" className="d-flex justify-content-start">
                <Button variant="primary" style={{marginRight:"3rem"}} onClick={e => executeSearch(e)}>検索</Button>
                <Button variant="clear" onClick={e => onClickClear(e)}>クリア</Button>
              </Col>
            </Form.Group>
          </Container>
        </Card>

        <Card style={{border: "none"}}>
          <Container className="container-main-button-area">
            <Row>
              <Col style={{textAlign: "right"}}>
                <Button as={Link} variant="primary" className="mr-4" to={"/exp_dtl/"}>
                  新規
                </Button>
                {/*<Button variant="secondary" id="btn-download" onClick={e => onClickDownload()}>*/}
                {/*<span>*/}
                {/*<FontAwesomeIcon icon={faFileDownload} size="lg"/>支払一覧*/}
                {/*</span>*/}
                {/*</Button>*/}
              </Col>
            </Row>
          </Container>
        </Card>

        <Container className="container-main-list">
          {/* *** 一覧 *** */}
          {/*<InitialLoading loadingCss={loadingCss}/>*/}
          <MdDataTable
            // tableRef={tableRef}
            keyField="row_id"
            listData={listData}
            columns={columns}
            loading={loading}
            onTableChange={onTableChange}
            page={locPage}
            sizePerPage={locSizePerPage}
            // selectRowProp={selectRowProp}
            // selected={selectedPayNos}
            totalSize={locTotalSize}
            sortField={locSortField}
            sortOrder={locSortOrder}
            showPagenation={true}
            // linkToAdd="/pay/"
            onClickLinkToDetail={onClickLinkToDetail}
            selectedRowId={selectedId}
            onKeyDownCtlEnterDataList={e => onKeyDownCtlEnterDataList(e)}
            onKeyDownEscDataList={e => onKeyDownEscDataList(e)}
            onKeyDownSpaceDataList={e => onKeyDownSpaceDataList(e)}
          />
        </Container>
      </div>
    </>
  );
}

export default withRouter(ExpList);